// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__34Zxm","inputWrap":"styles_inputWrap__GQIS_","input":"styles_input__1UDea"};